import React from 'react';

import { BtmCtn, CardCtn, CardBody, SvgCtn, TopCtn } from './index.style';

interface SummaryProps {
  summary: {
    count: number;
    title: string;
    icon: React.SVGProps<SVGSVGElement>;
  };
  onClick: ()=>{},
}

const JobSummaryCard: React.FC<SummaryProps> = ({ summary, onClick }): React.ReactElement => {

  return (
    <CardCtn onClick={onClick}>
      <CardBody>
        <TopCtn>
          <SvgCtn>{summary.icon}</SvgCtn>
        </TopCtn>
        <BtmCtn>
          <div>{summary.count}</div>
          <span>{summary.title}</span>
        </BtmCtn>
      </CardBody>
    </CardCtn>
  );
};

export default JobSummaryCard;
